import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
var ReservationDetail = function () {
    var id = useParams().id;
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", children: "Reservation Detail" }), _jsxs(Typography, { children: ["Reservation ID: ", id] })] }));
};
export default ReservationDetail;
